/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript !== "undefined")
		execScript(src);
	else
		eval.call(null, src);
}



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/script-loader/addScript.js
// module id = KF6U
// module chunks = 4